import {Stack} from '@mui/material'
import React, {useEffect, useState} from 'react'
import PhoneInputWithCountrySelect from 'react-phone-number-input'
import ErrorMsg from './NewMsgErr'
import {useSelector} from 'react-redux'
import {RootState} from '../../store'
import {useTranslation} from 'react-i18next'
import {filterSelectableCountries, selectableIso2Codes} from '../../utils/countryFilter'
import {CountryCode} from 'libphonenumber-js'
import Apiservices from '../../../lib/ApiServices'

export default function PhoneInput({setValue, value, data, setData, name, errors}: any) {
  const {t} = useTranslation()

  const store = useSelector((state: RootState) => state.vender)
  const countries = filterSelectableCountries(store.allCountries)
  const countryCodes = selectableIso2Codes(countries) as CountryCode[]
  const [detectedIso2, setDetectedIso2] = useState<CountryCode | ''>('')

  useEffect(() => {
    let cancelled = false
    const fallbackDial = countryCodes.includes('LB')
      ? '+961'
      : countries[0]?.country_code
    Apiservices.get('/geo/detect')
      .then((res) => {
        if (cancelled) return
        const iso2 = String(res.data?.data?.iso2 || '').toUpperCase() as CountryCode
        const dial = String(res.data?.data?.country_code || '')
        if (iso2 && countryCodes.includes(iso2)) {
          setDetectedIso2(iso2)
          setValue(dial || fallbackDial)
          return
        }
        if (fallbackDial) setValue(fallbackDial)
      })
      .catch(() => {
        if (!cancelled && fallbackDial) setValue(fallbackDial)
      })
    return () => {
      cancelled = true
    }
  }, [countryCodes.join(',')])

  const defaultIso2 =
    detectedIso2 || (countryCodes.includes('LB') ? 'LB' : countryCodes[0])

  return (
    <>
      <Stack
        direction={'row'}
        borderRadius={'6.18px'}
        border='1px solid var(--bs-gray-300)'
        width={'100%'}
        p={'0 13px'}
        bgcolor={'var(--bs-body-bg)'}
        height={'47px'}
        alignItems={'center'}
        sx={{background: 'var(--bs-body-bg)'}}
        dir='ltr'
      >
        <Stack
          height={'80%'}
          sx={{borderRight: '1px solid  var(--bs-gray-300)', background: 'var(--bs-body-bg)'}}
        >
          {countryCodes.length > 0 && (
            <PhoneInputWithCountrySelect
              style={{width: '110px', height: '38px'}}
              placeholder='Enter phone number'
              international
              defaultCountry={defaultIso2}
              addInternationalOption={false}
              value={value}
              disableCountryCode={true}
              readOnly={true}
              onChange={(phoneNumber: any) => {
                setValue(phoneNumber)
              }}
              countries={countryCodes}
            />
          )}
        </Stack>
        <input
          style={{
            border: 'none',
            background: 'var(--bs-body-bg)',
            padding: '12.0625px 13px 12.5px',
            color: 'var(--bs-text-dark)',
                        width: '100% !important',
                        minWidth:'100%'

          }}
          className='login-input'
          placeholder={t('NumberPhone') || ''}
          type='tel'
          value={data.mobile}
          onChange={(e: any) => setData({...data, [name]: e.target.value})}
        />
      </Stack>
      <ErrorMsg msgErr={errors['mobile']} />
    </>
  )
}
